import { useCallback } from 'react'
import type { CalendarEvent } from '@highlight/common'
import { useSetSidepanelState } from '@renderer/overlay/atoms'
import { useSetSidepanelHotkeyOpened } from '@renderer/overlay/Sidepanel/atoms'
import { useViewActions } from '@renderer/overlay/Sidepanel/view-atoms'
import { MEETING_VIEW_ID } from '@renderer/overlay/Sidepanel/components/meeting/meeting-view-id'
import { useRequestSidepanelPaywall } from '@renderer/overlay/Sidepanel/components/sidepanel/sidepanel-paywall-request'
import { getHasEventEnded } from '@shared/utils/connections/calendars'

export const OUT_OF_MEETING_HOURS_COPY = 'Out of Meeting Hours'
export const ADD_HOURS_TO_TRANSCRIBE_CTA = 'Add Hours to Transcribe'

/**
 * Where a meeting toast sends an out-of-hours user. The Meeting View docks the
 * meeting-hours paywall on any meeting that can still be recorded, so a calendar
 * event that has not ended opens there. A detected meeting often runs past its
 * calendar end, and one without a calendar event has no view at all, so those
 * get the home strip instead of a page with nothing to buy. Pinned open like
 * the meeting-limit paywall is, so the panel survives a Join CTA handing focus
 * to the browser in the same click.
 */
export function useOpenHoursPaywall() {
  const { openView } = useViewActions()
  const setSidepanelState = useSetSidepanelState()
  const setHotkeyOpened = useSetSidepanelHotkeyOpened()
  const openSidepanelPaywall = useRequestSidepanelPaywall()
  return useCallback(
    (meeting?: CalendarEvent) => {
      if (!meeting || getHasEventEnded(meeting)) {
        openSidepanelPaywall('hours')
        return
      }
      setHotkeyOpened(true)
      setSidepanelState('open')
      openView(
        MEETING_VIEW_ID,
        { mode: 'note', calendarEventId: meeting.id, title: meeting.title, meeting },
        { sourceLabel: 'Home' },
      )
    },
    [openView, setSidepanelState, setHotkeyOpened, openSidepanelPaywall],
  )
}
